// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".registration-form__requirement>hr[data-v-28ed02d0]{margin:1.25rem 0}.registration-form__requirement:last-child>hr[data-v-28ed02d0]{display:none}.warning[data-v-28ed02d0]{white-space:pre-line}", ""]);
// Exports
module.exports = exports;
